module.exports = __webpack_public_path__ + "static/media/financeHead.d9bce077.jpg";